import script from "./TcVsButton1.vue?vue&type=script&lang=ts&setup=true"
export * from "./TcVsButton1.vue?vue&type=script&lang=ts&setup=true"

import "./TcVsButton1.vue?vue&type=style&index=0&id=da124d0a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/registry.npmmirror.com+vue-loader@17.3.1_@vue+compiler-sfc@3.3.8_vue@3.3.8_webpack@5.89.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-da124d0a"]])

export default __exports__